import request from "@/utils/request";
export const ruleList = () =>
    request({
        url: '/auth-rule/rule-list',
        method: 'post',
        data: {},
    })